<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar />
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor link" @click="$toCatalogProduct($router)">&nbsp;Catalog / Product</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;{{pageAction}} {{isUnit ? "Unit":"Bundling"}} Product</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container" v-if="loadingPage">
                                <center><img src="~@/assets/images/load-button.gif" /></center>
                            </div>
                            <div class="container" v-else>
                                <div class="d-flex justify-content-between mb-5 mt-4">
                                    <div></div>
                                    <h5 class="m-auto" v-if="isUnit">{{pageAction}} Unit Product</h5>
                                    <h5 class="m-auto" v-else>{{pageAction}} Bundling Product</h5>
                                    <button class="btn btn-primary" @click="openModal('Log')">Show Log</button>
                                </div>
                                <div v-if="!isUnit">
                                    <div class="d-flex flex-wrap justify-content-between">
                                        <div class="card w-100 mt-4" v-for="(input, index) in productChoose" :key="`product-${index}`">
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between">
                                                    <div class="d-flex">
                                                        <span class="ol-label" style="font-weight: bold;">Product #{{index+1}}</span>
                                                    </div>
                                                    <div class="d-flex">
                                                        <input type="text" @keypress="isNumber($event)" name="" v-model="input.productId" class="form-control text-field" placeholder="Product ID" />
                                                        <button @click="searchProduct(index, input.productId)" class="btn btn-primary ml-2">Get</button>
                                                    </div>
                                                </div>
                                                <br />
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="w-100 d-flex align-items-center">
                                                            <span class="field-label"> Type </span>
                                                            <!-- {{input.product}} -->
                                                            <multiselect
                                                                v-model="input.product"
                                                                :options="getProductTypeBundling(index)"
                                                                label="catalogTypeName"
                                                                :allow-empty="false"
                                                                deselect-label=""
                                                                @input="onChangeProductTypeBundling(index)"
                                                                select-label=""
                                                                style=""
                                                                track-by="catalogTypeName" :disabled="pageAction.toLowerCase == 'edit'"
                                                            ></multiselect>
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="w-100 d-flex align-items-center">
                                                            <span class="field-label"> Name </span>
                                                            <multiselect
                                                                v-if="input.product!=null"
                                                                v-model="input.selectedproduct"
                                                                :options="getProductNameBundling(index)"
                                                                label="productTitle"
                                                                :allow-empty="false"
                                                                deselect-label=""
                                                                @input="onChangeProductNameBundling(index)"
                                                                select-label=""
                                                                style=""
                                                                track-by="productTitle"
                                                            ></multiselect>
                                                            <input v-else type="text" name="model" disabled class="form-control" placeholder="Please Choose Product Type" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mt-2">
                                                    <span class="field-label-one select"> Specifications </span>
                                                    <multiselect
                                                        v-if="input.selectedproduct!=null"
                                                        v-model="input.selectedproductid"
                                                        :options="getProductIdBundling(index)"
                                                        label="spec"
                                                        :allow-empty="false"
                                                        deselect-label=""
                                                        @input="onChangeProductIdBundling(index)"
                                                        select-label=""
                                                        style=""
                                                        placeholder="Select Product Detail"
                                                        track-by="spec"
                                                    ></multiselect>
                                                    <input v-else type="text" name="model" disabled class="form-control" placeholder="Please Choose Product Name" />
                                                </div>
                                                <br />
                                                <div class="d-flex justify-content-end mt-2" v-if="productChoose.length>1">
                                                    <button class="btn btn-danger" @click="deleteRowProduct(index)" style="margin-right: 10px;">Cancel Product</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end mt-2">
                                        <button class="btn btn-primary" @click="addRowProduct()">More Product</button>
                                    </div>
                                </div>
                                <div class="row" v-if="isUnit">
                                    <div class="col-6">
                                        <div class="d-flex align-items-center">
                                            <span class="field-label-one select"> Type </span>
                                            <multiselect
                                                v-model="addType"
                                                :options="$getProductType('unit','no')"
                                                label="statusName"
                                                :allow-empty="false"
                                                :select-label="'Type'"
                                                :deselect-label="''"
                                                placeholder="Select Product Type"
                                                track-by="statusName"
                                                :disabled="pageAction.toLowerCase() == 'edit'"
                                            ></multiselect>
                                        </div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="field-label-one select"> Brand </span>
                                            <multiselect v-model="productDetail.brand" :options="catalogBrand" :allow-empty="false" :select-label="'Brand'" deselect-label="Can't remove this value" placeholder="Product Brand" :disabled="pageAction.toLowerCase() == 'edit'"></multiselect>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="productDetail.brand == 'Other'">
                                            <label class="field-label-one"> New Brand </label>
                                            <input type="text" name="product" class="form-control" v-model="newBrand" />
                                        </div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="field-label-one"> Model </span>
                                            <input type="text" name="model" class="form-control" v-model="productDetail.model" placeholder="Product Model" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '1' ||this.addType.status == '2'|| this.addType.status == '5'||this.addType.status == '6'">
                                            <span class="field-label-one"> Processor </span>
                                            <input type="text" name="processor" class="form-control" v-model="productDetail.processor" placeholder="Product Processor" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '1' ||this.addType.status == '2'|| this.addType.status == '5'||this.addType.status == '6'">
                                            <span class="field-label ram"> RAM </span>
                                            <input type="text" name="ram" class="form-control" v-model="productDetail.ram" @keypress="isNumber($event)" placeholder="Product RAM" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> GB </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '5' || this.addType.status == '6'">
                                            <span class="field-label storage-ssd"> Storage </span>
                                            <input type="text" name="storage" class="form-control" v-model="addStorageSmartphone[0]" @keypress="isNumber($event)" placeholder="Product Storage" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> GB </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="addType.status == 4 || addType.status == 5 || addType.status == 6">
                                            <label class="field-label-one" style="margin-top: -50px;"> Feature </label>
                                            <textarea type="text" name="feature" class="form-control" v-model="productDetail.feature" rows="3" :disabled="pageAction.toLowerCase() == 'edit'" style="resize: none;"></textarea>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '1'">
                                            <span class="field-label storage"> Storage <span v-if="storageType == 'HDD+SSD'">(HDD)</span></span>
                                            <select class="form-control storage-type mr-2" name="storage_type" v-model="storageType" :disabled="pageAction.toLowerCase() == 'edit'">
                                                <option value="SSD">SSD</option>
                                                <option value="HDD">HDD</option>
                                                <option value="HDD+SSD">HDD+SSD</option>
                                            </select>
                                            <input type="text" name="storage" class="form-control" v-model="addStorage[0]" @keypress="isNumber($event)" placeholder="Spec - Storage" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> GB </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '1' && storageType == 'HDD+SSD'">
                                            <span class="field-label storage-ssd"> Storage (SSD)</span>
                                            <input type="text" name="storage" class="form-control" v-model="addStorage[1]" @keypress="isNumber($event)" placeholder="Spec - Storage" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> GB </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '4'">
                                            <span class="field-label-one"> Color Technology </span>
                                            <input type="text" name="colorTech" class="form-control" v-model="productDetail.colorTech" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '3'">
                                            <span class="field-label-one screen"> Screen Size </span>
                                            <input type="text" name="displaysize" class="form-control" v-model="productDetail.displaySize" @keypress="isNumber($event)" placeholder="Screen Size" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> Inch </span>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="this.addType.status == '3'" style="margin-top: 20px;">
                                            <span class="field-label-one radio"> Screen Panel </span>
                                            <div class="d-flex">
                                                <span class="mr-2">:</span>
                                                <div class="form-check">
                                                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="lcd" v-model="productDetail.displayType" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        LCD
                                                    </label>
                                                </div>
                                                <div class="form-check ml-2">
                                                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="led" v-model="productDetail.displayType" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        LED
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="this.addType.status == '3'" style="margin-top: 20px;">
                                            <span class="field-label-one radio"> VGA Port</span>
                                            <div class="d-flex">
                                                <span class="mr-2">:</span>
                                                <div class="form-check">
                                                    <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios1" value="Tersedia" v-model="productDetail.portVga" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        Support
                                                    </label>
                                                </div>
                                                <div class="form-check ml-2">
                                                    <input class="form-check-input" type="radio" name="exampleRadios1s" id="exampleRadios1s" value="Tidak Ada" v-model="productDetail.portVga" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="d-flex align-items-center mt-2" v-if="addType.status == 5 || addType.status == 6">
                                            <label class="field-label-one"> Feature </label>
                                            <input type="text" name="product" class="form-control" v-model="productDetail.feature" />
                                        </div> -->
                                    </div>
                                    <div class="col-6">
                                        <div class="d-flex align-items-center" v-if="this.addType.status == '3'">
                                            <span class="field-label-one radio"> HDMI Port </span>
                                            <div class="d-flex">
                                                <span class="mr-2">:</span>
                                                <div class="form-check">
                                                    <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="Tersedia" v-model="productDetail.portHdmi" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        Support
                                                    </label>
                                                </div>
                                                <div class="form-check ml-2">
                                                    <input class="form-check-input" type="radio" name="exampleRadios2s" id="exampleRadios2s" value="Tidak Ada" v-model="productDetail.portHdmi" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="this.addType.status == '3'" style="margin-top: 20px;">
                                            <span class="field-label-one radio"> Port DVI-D </span>
                                            <div class="d-flex">
                                                <span class="mr-2">:</span>
                                                <div class="form-check">
                                                    <input class="form-check-input" type="radio" name="exampleRadios3" id="exampleRadios3" value="Tersedia" v-model="productDetail.portDvid" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        Support
                                                    </label>
                                                </div>
                                                <div class="form-check ml-2">
                                                    <input class="form-check-input" type="radio" name="exampleRadios3s" id="exampleRadios3s" value="Tidak Ada" v-model="productDetail.portDvid" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                                    <label class="form-check-label" for="exampleRadios3s">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="this.addType.status == '5' || this.addType.status == '6'">
                                            <span class="field-label screen"> Screen </span>
                                            <input type="text" name="displaysize" class="form-control" v-model="productDetail.screen" @keypress="isNumber($event)" placeholder="Product Screen Size" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> Inch </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '5'||this.addType.status == '6'">
                                            <span class="field-label-one"> Rear Camera </span>
                                            <input type="text" name="productDetail.mainCamera" class="form-control" v-model="productDetail.mainCamera" placeholder="Product Rear Camera" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                        </div>

                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '5'||this.addType.status == '6'">
                                            <span class="field-label-one"> Front Camera </span>
                                            <input type="text" name="productDetail.frontCamera" class="form-control" v-model="productDetail.frontCamera" placeholder="Product Front Camera" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="this.addType.status == '2'">
                                            <span class="field-label storage"> Storage <span v-if="storageType == 'HDD+SSD'">(HDD)</span></span>
                                            <select class="form-control storage-type mr-2" name="storage_type" v-model="storageType" :disabled="pageAction.toLowerCase() == 'edit'">
                                                <option value="SSD">SSD</option>
                                                <option value="HDD">HDD</option>
                                                <option value="HDD+SSD">HDD+SSD</option>
                                            </select>
                                            <input type="text" name="storage" class="form-control" v-model="addStorage[0]" @keypress="isNumber($event)" placeholder="Spec - Storage" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> GB </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '2' && storageType == 'HDD+SSD'">
                                            <span class="field-label storage-ssd"> Storage (SSD)</span>
                                            <input type="text" name="storage" class="form-control" v-model="addStorage[1]" @keypress="isNumber($event)" placeholder="Spec - Storage" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> GB </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '1'||this.addType.status == '2'">
                                            <label class="field-label-one"> Graphics Card </label>
                                            <input type="text" name="vga" class="form-control" v-model="vgaInput" placeholder="Product Graphic Card" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '1'">
                                            <span class="field-label screen"> Screen </span>
                                            <input type="text" name="displaysize" class="form-control" v-model="productDetail.screen" @keypress="isNumber($event)" placeholder="Product Screen" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> Inch </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2" v-if="this.addType.status == '5'||this.addType.status == '6'">
                                            <span class="field-label battery"> Battery</span>
                                            <input type="text" name="battery" class="form-control" v-model="productDetail.battery" @keypress="isNumber($event)" placeholder="Product Battery" :disabled="pageAction.toLowerCase() == 'edit'"/>
                                            <span class="ml-2 mt-auto mb-auto"> mAh </span>
                                        </div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="field-label-one rp"> Sum Insured </span>
                                            <div class="input-group">
                                                <span class="input-group-addon" style="margin-left: 0px;"> <label class="label-addon-rp">Rp</label></span>
                                                <!-- <input type="text" class="form-control" name="price" @keypress="isNumber($event)" v-model="sumInsurance" placeholder="Sum Insured" /> -->
                                                <money type="text" class="form-control form-input input-lg" name="price" v-bind="money" @keypress="isNumber($event)" v-model="sumInsurance"></money>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center mb-2" v-if="addType.status > 6" style="padding-top: 5px;">
                                            <span class="field-label-one"> Specification </span>
                                            <input type="text" class="form-control" name="" v-model="productDetail.specifications" />
                                        </div>
                                        <div class="d-flex align-items-center mb-2" style="padding-top: 5px;" v-if="addType.status < 7">
                                            <span class="field-label-one select"> Category </span>
                                            <multiselect
                                                v-model="addCategory"
                                                :options="catalogCategory"
                                                label="statusName"
                                                :allow-empty="false"
                                                :select-label="'Type'"
                                                :deselect-label="''"
                                                placeholder="Select Product Category"
                                                track-by="statusName"
                                            ></multiselect>
                                        </div>
                                        <div class="d-flex align-items-center mt-2">
                                            <span class="field-label-one"> Year </span>
                                            <input type="text" @keypress="isNumber($event)" maxlength="4" name="processor" class="form-control" v-model="year" placeholder="Production Year" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!isUnit">
                                    <br />
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="w-100 d-flex align-items-center">
                                                <span class="field-label-one select"> Category </span>
                                                <multiselect
                                                    v-model="addCategory"
                                                    :options="catalogCategory"
                                                    label="statusName"
                                                    :allow-empty="false"
                                                    :select-label="'Type'"
                                                    :deselect-label="''"
                                                    placeholder="Select Product Category"
                                                    track-by="statusName"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="w-100 d-flex align-items-center">
                                                <span class="field-label"> Name </span>
                                                <input type="text" v-model="addName" name="input" class="form-control text-field" placeholder="Product Name" />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                                <div class="mt-5">
                                    <span class="ol-label">Pictures</span>
                                    <div class="d-flex flex-wrap justify-content-between">
                                        <div class="one-file text-center" v-for="(input, index) in addPhoto" style="padding-top: 10px;" :key="`photo-${index}`">
                                            <div style="min-height: 257px; display: block;">
                                                <center>
                                                    <img style="max-height: 257px;" :src="input.imgUrl" class="img-responsive" :id="'show_img_' + index" />
                                                </center>
                                            </div>
                                            <div class="one-line-file text-center">
                                                <input type="file" name="" class="form-control-file form-control-sm" :id="'file_img_' + index" @change="onFilePicked($event,index)" ref="inputImage" hidden />
                                                <div class="d-flex">
                                                    <button class="btn btn-primary btn-sm mr-2 mt-2 w-100" @click="pickFile(index)">Browse</button>
                                                    <button class="btn btn-danger btn-sm mt-2 w-100" @click="removeImage(index)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <label class="ol-label"> Description</label>
                                    <div>
                                        <textarea class="form-control form-control-sm" rows="5" id="description" v-model="addDescription" style="resize: none;"></textarea>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap mt-5 justify-content-between">
                                    <div class="card w-49 mt-4" v-for="(input, index) in tenor" :key="`tenor-${index}`">
                                        <div class="card-body">
                                            <span class="ol-label" style="font-weight: bold;">Tenor #{{1+index}}</span>
                                            <div class="d-flex align-items-center">
                                                <span class="field-label"> Tenor </span>
                                                <input type="text" @keypress="isNumber($event)" name="input" v-model="input.duration" class="form-control text-field" placeholder="Duration" />
                                                <span class="ml-2">month</span>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label"> Rent Fee </span>
                                                <div class="input-group">
                                                    <span class="input-group-addon" style="margin-left: 0px;"> <label class="label-addon-rp">Rp</label></span>
                                                    <!-- <input type="text" placeholder="Rent Fee" class="form-control" name="price" @keypress="isNumber($event)" v-model="input.rentFee" /> -->
                                                    <money type="text" class="form-control form-input input-lg" name="price" v-bind="money" @keypress="isNumber($event)" v-model="input.rentFee"></money>
                                                </div>
                                                <span class="ml-2">month</span>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label-one"> Condition </span>
                                                <multiselect
                                                    v-model="input.condition"
                                                    :options="conditionList"
                                                    label="conditionName"
                                                    :allow-empty="false"
                                                    deselect-label=""
                                                    select-label=""
                                                    style=""
                                                    placeholder="Select Condition"
                                                    track-by="conditionName"
                                                ></multiselect>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label-one"> Status </span>
                                                <multiselect
                                                    v-model="input.status"
                                                    :options="$getConstants('CATALOG_STATUS','no')"
                                                    label="statusName"
                                                    :allow-empty="false"
                                                    :select-label="''"
                                                    :deselect-label="''"
                                                    placeholder="Status"
                                                    track-by="statusName"
                                                ></multiselect>
                                            </div>
                                            <br />
                                            <div class="d-flex justify-content-end mt-2" v-if="(tenor.length>1 && isAddForm ) || (editTenor.length <= index && !isAddForm )  ">
                                                <button class="btn btn-danger" @click="deleteRowTenor(index)" style="margin-right: 10px;">Cancel Tenor</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex mt-4 justify-content-end">
                                    <div>
                                        <!-- <button class="btn btn-danger btn-sm" @click="$toCatalogProduct($router)">Cancel</button> -->
                                        <button v-if="pageAction.toLowerCase() == 'edit' && (productTypeEdit == 1 || productTypeEdit == 2)" class="btn btn-info btn-sm" @click="toPage('/catalog/bom/' + catalogId + '?unit=' + isUnit)">View BOM ({{totalBom}})</button>
                                        <button class="btn btn-success btn-sm" @click="addRowTenor()">Add Tenor</button>
                                        <button class="btn btn-primary btn-sm" @click="submitAddBundling()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- Modal Save-->
            <div class="modal fade" id="modalSave" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Save Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to save product {{ productDetail.model }} ?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="saveCatalog()">Save</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <div class="modal fade" id="modalLog" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-xl">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">{{ productLogName }} Log</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead class="">
                                    <tr>
                                        <th>When</th>
                                        <th>What</th>
                                        <th>Who</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingLog === false && dataLog.length == '0'">
                                        <td colspan="3" class="text-center">Data Not Available</td>
                                    </tr>
                                    <tr v-else-if="loadingLog === true">
                                        <td colspan="3" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                                    </tr>
                                    <tr v-for="(data,index) in dataLog" v-else :key="`log-${index}`">
                                        <td>{{data.time}}</td>
                                        <td v-html="data.text"></td>
                                        <td>{{data.ids}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from "sweetalert";
    import Multiselect from "vue-multiselect";
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import SideBar from "../SideBar";
    import CONSTANT from "../constPlugin";
    import { Money } from "v-money";
    export default {
        name: "ProductAddPage",
        components: {
            SideBar,
            Multiselect,
            Money,
        },
        data() {
            return {
                spaceRegex: /[\u00A0\uFEFF\u202F]|\s{2,}/g,
                totalBom: 0,
                money: {
                    decimal: ",",
                    thousands: ".",
                    prefix: "",
                    suffix: "",
                    precision: 0,
                    masked: false,
                },
                isUnit: true,
                isAddForm: true,
                fProducts: [],
                loadingPage: true,
                catalogUnitType:[],

                // bundling
                productIdChoose: [],
                productChoose: [],
                selectedProducts: [
                    {
                        status: "1",
                        statusName: "New",
                    },
                ],
                addCategory: "",
                addNewCategory: "",
                addName: "",

                // unit
                productDetail: {},
                vgaInput: 'INTEL HD',
                year: "",
                productId: "",
                productDetailResult: {},

                // all
                tenor: [],
                admin: "",
                selectedCategory: "",
                catalogId: 0,
                editTenor: [],

                permission: [],
                viewDashboard: false,
                viewOrder: false,
                viewReturn: false,
                viewProduct: false,
                viewPairing: false,
                viewReconcile: false,
                viewResolution: false,
                viewLessor: false,
                viewLessee: false,
                viewEmployee: false,
                editOrder: false,
                editReturn: false,
                editProduct: false,
                editPairing: false,
                editReconcile: false,
                editResolution: false,
                editLessor: false,
                editLessee: false,
                editEmployee: false,

                loadingButtonProcess: false,

                loadingLog: false,
                totalPage: 0,
                totalData: 0,
                currentPage: 1,

                catalogCategory: [],
                productType: [],
                catalogBrand: [],

                productDisplayType: ["LCD", "LED"],
                productVGA: ["Tersedia", "Tidak Ada"],
                productDVID: ["Tersedia", "Tidak Ada"],
                productHDMI: ["Tersedia", "Tidak Ada"],

                addType: [],
                addStorage: [],
                addStorageSmartphone: [],

                addDescription: "",

                addPhoto: [],
                imgFile: "",
                imgFileName: "",
                imgBase64: "",
                imgUrl: "",

                newBrand: "",
                storageType: "SSD",
                storageTypeSmartphone: "EMMC",
                temp: [],
                sumInsurance: "",
                dataLog: [1],
                pageAction: "",
                productLogName:"",
                productTypeEdit:"",

                // condition
                conditionList : []
            };
        },
        methods: {
            toFormPage(id) {
                this.$router.push({
                    path: "/catalog/form",
                    query: {
                        f: "Edit",
                        unit: 1,
                        catalogId: id
                    },
                });
            },
            connectLogCatalog: function () {
                this.$http
                    .get(process.env.LOG_URL + "/catalog_product/" + this.catalogId, {
                        headers: { "Asani-Token": localStorage.getItem("jwt") },
                    })
                    .then((response) => {
                        if (response.data.status === 200) {
                            this.dataLog = response.data.content;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            getProductTypeBundling(index) {
                return this.fProducts;
            },
            onChangeProductTypeBundling(index) {
                if (this.productChoose[index].selectedproduct != null) {
                    this.productChoose[index].selectedproduct = null;
                    this.productChoose[index].productId = null;
                    this.productChoose[index].selectedproductid = null;
                }
            },
            getProductNameBundling(index) {
                if (this.productChoose[index].product != null && this.productChoose[index].product.productGroup != null) return this.productChoose[index].product.productGroup;
                return this.fProducts[0].products;
            },
            onChangeProductNameBundling(index) {
                if (this.productChoose[index].selectedproductid != null) {
                    this.productChoose[index].productId = null;
                    this.productChoose[index].selectedproductid = null;
                }
            },
            getProductIdBundling(index) {
                if (this.productChoose[index].product != null && this.productChoose[index].selectedproduct != null) {
                    var newData = [];
                    if (this.productChoose[index].selectedproduct != null) {
                        for (var ii = 0; ii < this.productChoose[index].selectedproduct.products.length; ii++) {
                            newData.push(this.productChoose[index].selectedproduct.products[ii]);
                            newData[ii].spec = this.$getSpecificationText(this.productChoose[index].selectedproduct.products[ii].productDetail, this.productChoose[index].product.catalogTypeId);
                        }
                    }
                    return newData;
                }
                return this.fProducts[0].products;
            },
            onChangeProductIdBundling(index) {
                this.productChoose[index].productId = this.productChoose[index].selectedproductid.productId;
            },
            addRowProduct() {
                this.productChoose.push({
                    product: null,
                    productId: null,
                    selectedproduct: null,
                    selectedproductid: null,
                    catalogTypeId: "",
                    catalogTypeName: "",
                });
            },
            deleteRowProduct(index) {
                this.productChoose.splice(index, 1);
            },
            searchProduct(indexChosenProduct, id) {
                var sproduct = "";
                var sproductname = "";
                var sproductid = "";
                for (var index = 0; index < this.fProducts.length; index++) {
                    for (var i = 0; i < this.fProducts[index].productGroup.length; i++) {
                        for (var iv = 0; iv < this.fProducts[index].productGroup[i].products.length; iv++) {
                            if (this.fProducts[index].productGroup[i].products[iv].productId == parseInt(id)) {
                                sproduct = this.fProducts[index];
                                sproductname = this.fProducts[index].productGroup[i];
                                sproductid = this.fProducts[index].productGroup[i].products[iv];
                            }
                        }
                    }
                }
                if (this.productChoose.length <= indexChosenProduct) {
                    this.addRowProduct();
                }
                if (sproduct != null && sproduct != "") {
                    this.productChoose[indexChosenProduct].product = sproduct;
                    this.productChoose[indexChosenProduct].selectedproduct = sproductname;
                    this.productChoose[indexChosenProduct].selectedproductid = sproductid;
                    this.productChoose[indexChosenProduct].productId = sproductid.productId;
                } else {
                    swal("Sorry", "Product Not found", "error", {
                        button: "Ok",
                    });
                }
            },
            addRowTenor() {
                this.tenor.push({
                    status: null,
                });
            },
            deleteRowTenor(index) {
                this.tenor.splice(index, 1);
            },
            pickFile(index) {
                this.$refs["inputImage"][index].click();
            },
            validateBundlingProduct() {
                if (this.productChoose.length < 2) {
                    swal("Sorry", "Product must be more than 1", "error", {
                            button: "Ok",
                        });
                        return false;
                } else if (this.addName != null && this.addName == "") {
                    swal("Sorry", "Product Name must be entered", "error", {
                            button: "Ok",
                        });
                        return false;
                }
                for (var ii = 0; ii < this.productChoose.length; ii++) {
                    var idx = ii + 1;
                    if (this.productChoose[ii].selectedproductid == null) {
                        swal("Sorry",  "Please input Product #" + idx, "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productChoose[ii].selectedproductid.productId != this.productChoose[ii].productId) {
                        swal("Sorry", "Product ID and Product Detail #" + idx + " doesn't match. Please click 'Get' Button", "error", {
                            button: "Ok",
                        });
                        return false;
                    }
                }
                return true;
            },
            validateTenor() {
                var valid = true;
                var message = "";
                for (var ii = 0; ii < this.tenor.length; ii++) {
                    if (this.tenor[ii].duration == null || this.tenor[ii].duration == "") {
                        valid = false;
                        message = "Duration";
                    } else if (this.tenor[ii].rentFee == null || this.tenor[ii].rentFee == "") {
                        valid = false;
                        message = "Rent Fee";
                    } else if (this.tenor[ii].condition == null) {
                        valid = false;
                        message = "Condition";
                    } else if (this.tenor[ii].status == null) {
                        valid = false;
                        message = "Status";
                    }
                    message = message + " must be select";
                    if (valid) {
                        valid = !this.isDuplicateTenor(ii, this.tenor[ii]);
                        message = "Tenor is duplicate. Please Check.";
                    }
                    if (!valid) {
                        break;
                    }
                }
                if (!valid)
                    swal("Sorry", message, "error", {
                        button: "Ok",
                    });
                return valid;
            },
            isDuplicateTenor(index, sTenor) {
                var mTenorString = JSON.stringify(this.initTenor(sTenor))
                for (var ii = 0; ii < this.tenor.length; ii++) {
                    var jsonVar = JSON.stringify(this.initTenor(this.tenor[ii]));
                    if (ii != index && mTenorString == jsonVar) {
                        return true;
                    }
                }
                return false;
            },
            initTenor(sTenor){
                return {
                    duration:sTenor.duration,
                    rentFee:sTenor.rentFee,
                    condition:sTenor.condition,
                    status:sTenor.status.status
                }

            },
            validatePhoto() {
                var valid = false;
                var message = "Image";
                for (var ii = 0; ii < this.addPhoto.length; ii++) {
                    if (this.addPhoto[ii].imgFileName != null && this.addPhoto[ii].imgFileName != "") {
                        valid = true;
                    }
                }
                if (!valid)
                    swal("Sorry", message + " must be select", "error", {
                        button: "Ok",
                    });
                return valid;
            },
            validateCategory() {
                if (this.addType.status > 6) {
                    return true;
                }
                var valid = true;
                var message = "Category";
                if (this.addCategory == null || (this.addCategory != null && this.addCategory == "")) {
                    valid = false;
                } else if (this.addCategory.status == "New" && (this.addNewCategory == null || this.addNewCategory == "")) {
                    valid = false;
                }
                if (!valid)
                    swal("Sorry", message + " must be entered", "error", {
                        button: "Ok",
                    });
                return valid;
            },
            productIdBundling() {
                var productsIds = "";
                for (var ii = 0; ii < this.productChoose.length; ii++) {
                    var comma = ",";
                    if (ii == 0) comma = "";
                    productsIds = productsIds + comma + this.productChoose[ii].productId;
                }
                return productsIds;
            },
            submitAddBundling() {
                if (this.validateCategory() && this.validatePhoto() && this.validateTenor()) {
                    if (!this.isUnit) {
                        if (this.validateBundlingProduct()) {
                            this.openModal("Save");
                        }
                    } else {
                        this.validationUnit("Save");
                    }
                }
            },
            saveCatalog() {
                if (this.isAddForm) {
                    this.hitAddBundling(process.env.ADD_CATALOG_BUNDLING, this.productIdBundling());
                } else {
                    console.log('edit')
                    this.hitAddBundling(process.env.EDIT_CATALOG, this.catalogId);
                }
            },
            hitAddBundling(url, productIds) {
                this.loadingButtonProcess = true
                var category = this.addCategory.statusName;
                if (this.addCategory.status == "New") {
                    category = this.addNewCategory;
                }
                var name = this.addName;
                if (name == "" || this.isUnit) {
                    name = this.productDetail.brand + " " + this.productDetail.model;
                }
                var products = this.productId;
                if (!this.isUnit) {
                    products = this.productIdBundling();
                }
                
               const tenorData = this.tenor.map(item => {
                return {...item, condition : item.condition.conditionName}
               })
               const cleanedName = (name || "").replace(this.spaceRegex, ' ').trim()
               const cleanedDescription = (this.addDescription || "").replace(this.spaceRegex, ' ').trim()
                this.$http
                    .post(
                        url,
                        {
                            product: products,
                            catalogCategory: category,
                            name: cleanedName,
                            description: cleanedDescription,
                            photo: this.addPhoto,
                            tenor: tenorData,
                            adminId: this.adminId,
                            year: this.year,
                            isUnit: this.isUnit,
                            productType: Number(this.addType.status),
                            productTypeString: this.addType.statusName,
                            productDetail: this.productDetailResult,
                            catalogId: Number(this.catalogId),
                            sumInsurance: Number(this.sumInsurance ? this.sumInsurance : 0),
                        },
                        {
                            timeout: 300 * 1000,
                            headers: {
                                "Asani-Token": localStorage.getItem("jwt"),
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                        } else if (response.data.status == 200) {
                            swal("Success", response.data.message, "success", {
                                buttons: {
                                    agree: "OK",
                                },
                            }).then((value) => {
                                if (this.pageAction.toLowerCase() == 'edit') {
                                    $("#modalSave").modal("hide");
                                    this.toFormPage(this.catalogId)
                                }else{
                                    this.toFormPage(response.data.content)
                                }
                            });
                        } else if (response.data.status == 201) {
                            swal("Failed", response.data.message, "error", {
                                button: "Close",
                            });
                        } else {
                            swal("Failed", response.data.status+" "+response.data.message, "error", {
                                button: "Close",
                            });
                        }
                        this.loadingButtonProcess = false;
                    })
                    .catch(error => {
                        this.loadingButtonProcess = false;
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    });
            },
            getCatalogEdit() {
                this.$http
                    .post(
                        process.env.GET_CATALOG_EDIT,
                        {
                            catalogId: Number(this.catalogId),
                            isUnit: this.isUnit,
                        },
                        {
                            headers: {
                                "Asani-Token": localStorage.getItem("jwt"),
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                        } else if (response.data.status == 200) {
                            this.addType = this.$getConstantsObjectS("PRODUCT_TYPE", response.data.content.productType);
                            if (this.isUnit) {
                                this.productTypeEdit = response.data.content.productType
                                this.productDetail = response.data.content.productDetail;
                                this.sumInsurance = response.data.content.sumInsurance;
                                this.year = response.data.content.year;
                                this.productId = response.data.content.product;
                                this.vgaInput = response.data.content.productDetail.vga
                                // console.log(CONSTANT.PRODUCT_TYPE_MONITOR.status)
                                if(this.addType.status != CONSTANT.PRODUCT_TYPE_MONITOR.status && this.addType.status != CONSTANT.PRODUCT_TYPE_PRINTER.status)
                                this.initStorage(this.productDetail.storage);
                            } else {
                                this.initProducts(response.data.content.product);
                            }

                            this.addCategory = response.data.content.catalogCategory;
                            this.addName = response.data.content.name;
                            this.productLogName = response.data.content.name;
                            this.addDescription = response.data.content.description;

                            if (response.data.content.photo != null && response.data.content.photo.length > 0) {
                                for (var j = 0; j < response.data.content.photo.length; j++) {
                                    this.addPhoto[j] = {
                                        imgFileName: response.data.content.photo[j].imgFileName,
                                        imgBase64: "",
                                        imgUrl: response.data.content.photo[j].imgUrl,
                                        photoId: response.data.content.photo[j].photoId,
                                    };
                                }
                            }

                            if (response.data.content.tenor != null && response.data.content.tenor.length > 0) {
                                this.tenor = response.data.content.tenor;
                              
                                for (var i = 0; i < this.tenor.length; i++) {
                                    this.tenor[i].condition = {conditionName : this.tenor[i].condition}
                                    this.tenor[i].status = this.$getConstantsObjectS("CATALOG_STATUS", response.data.content.tenor[i].status);
                                }
                                this.editTenor = this.tenor.slice();
                            } else {
                                this.addRowTenor();
                            }
                            this.loadingButtonProcess = false;
                            this.loadingPage = false;
                            this.connectLogCatalog();
                        } else if (response.data.status == 201) {
                            swal("Failed", response.data.message, "error", {
                                button: "Close",
                            });
                            this.loadingButtonProcess = false;
                        }else {
                            swal("Failed", response.data.status.toString()+" "+response.data.message, "error", {
                                button: "Close",
                            });
                        }
                        this.loadingButtonProcess = false;
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    });
            },
            initPhoto() {
                this.addPhoto = [];
                for (var i = 0; i < 4; i++) {
                    this.addPhoto.push(this.initPhotoObject(0, "", "", ""));
                }
            },
            initPhotoObject(id, name, imgBase, url) {
                if (url == "") {
                    url = "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg";
                    id = id;
                    imgBase = "";
                    name = "";
                }
                return {
                    imgFileName: name,
                    imgBase64: imgBase,
                    imgUrl: url,
                    photoId: id,
                };
            },
            initStorage(storage) {
                // storage="250GB HDD , 250GB SSD"
                var res = storage.replace(/\s/g, "").replace(",", "GB").split("GB");
                console.log('resstorage',res)
                if (res.length > 2) {
                    this.storageType = "HDD+SSD";
                    this.addStorage[0] = res[0];
                    this.addStorage[1] = res[2];
                } else {
                    this.addStorage[0] = res[0];
                    this.addStorageSmartphone[0] = res[0];
                    this.storageType = res[1];
                }
                console.log(this.addStorage)
            },
            initProducts(products) {
                var res = products.split(",");
                this.productChoose = [];
                for (var i = 0; i < res.length; i++) {
                    this.searchProduct(i, parseInt(res[i]));
                }
            },
            validationUnit(x) {
                var valid = true;
                if (this.newBrand != null && this.newBrand != "") {
                    this.productDetail.brand = this.newBrand;
                }
                if (this.addType == null || this.addType == "") {
                    swal("Sorry", "Product type must be select", "error", {
                        button: "Ok",
                    });
                    valid = false;
                } else if (this.productDetail.brand == null || this.productDetail.brand == "") {
                    swal("Sorry", "Product Brand must be select", "error", {
                        button: "Ok",
                    });
                    valid = false;
                } else if (this.productDetail.brand == "Other" && this.newBrand == "") {
                    swal("Sorry", "New Brand must be fill", "error", {
                        button: "Ok",
                    });
                    valid = false;
                } else if (this.year == null || this.year == "") {
                    swal("Sorry", "Year must be select", "error", {
                        button: "Ok",
                    });
                    valid = false;
                } else if (this.sumInsurance == null || this.sumInsurance == "" || this.sumInsurance == "0") {
                    this.sumInsurance = 0
                    // swal("Sorry", "Sum Insured must be select", "error", {
                    //     button: "Ok",
                    // });
                    // valid = false;
                }
                if (valid && this.cekBottomofBrand(this.addType.status)) {
                    this.openModal(x);
                }
            },
            checkSpecificationCPU(type) {
                if (type != 2 &&this.productDetail.screen == null ||  this.productDetail.screen == "") {
                    swal("Sorry", "Product Screen must be fill", "error", {
                        button: "Ok",
                    });
                    return false;
                } else if (this.productDetail.processor == null || this.productDetail.processor == "") {
                    swal("Sorry", "Product Processor must be fill", "error", {
                        button: "Ok",
                    });
                    return false;
                } else if (this.productDetail.ram == null || this.productDetail.ram == "") {
                    swal("Sorry", "Product RAM must be fill", "error", {
                        button: "Ok",
                    });
                    return false;
                }
                return true;
            },
            cekBottomofBrand: function (type) {
                this.productDetailResult = {}
                if (this.productDetail.model == null || this.productDetail.model == "") {
                    swal("Sorry", "Product Model must be fill", "error", {
                        button: "Ok",
                    });
                    return false;
                } else if (type == 1 || type == 2) {
                    if (!this.checkSpecificationCPU(type)) {
                        return false;
                    }
                    if (this.storageType == "HDD+SSD") {
                        if (this.addStorage[1] == null || this.addStorage[1] == "") {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            });
                            return false;
                        }
                    }
                    if (this.addStorage[0] == null || this.addStorage[0] == "") {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.vgaInput == null || this.vgaInput == "") {
                        swal("Sorry", "Product Graphic Card must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    }

                    var storage = "";
                    if (this.storageType == "HDD+SSD") {
                        storage = this.addStorage[0] + "GB HDD," + this.addStorage[1] + "GB SSD";
                    } else {
                        storage = this.addStorage[0] + "GB " + this.storageType;
                    }
                    if (type == 1) {
                        this.productDetailResult = {
                            brand: this.productDetail.brand,
                            model: (this.productDetail.model || "").replace(this.spaceRegex, ' ').trim(),
                            screen: this.productDetail.screen.toString(),
                            processor: (this.productDetail.processor || "").replace(this.spaceRegex, ' ').trim(),
                            ram: this.productDetail.ram.toString(),
                            storage: storage,
                            vga: (this.vgaInput || "").replace(this.spaceRegex, ' ').trim(),
                        };
                    } else {
                        this.productDetailResult = {
                            brand: this.productDetail.brand,
                            model: (this.productDetail.model || "").replace(this.spaceRegex, ' ').trim(),
                            processor: (this.productDetail.processor || "").replace(this.spaceRegex, ' ').trim(),
                            ram: this.productDetail.ram.toString(),
                            storage: storage,
                            vga: (this.vgaInput || "").replace(this.spaceRegex, ' ').trim(),
                        };
                    }
                } else if (type == 5 || type == 6) {
                    // console.log(this.checkSpecificationCPU(type))
                    if (!this.checkSpecificationCPU(type)) {
                        return false;
                    }
                    if (this.addStorageSmartphone == null || this.addStorageSmartphone == "") {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.battery == null || this.productDetail.battery == "") {
                        swal("Sorry", "Product Battery must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.feature == null || this.productDetail.feature == "") {
                        swal("Sorry", "Product Feature must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.mainCamera == null || this.productDetail.mainCamera == "") {
                        swal("Sorry", "Product Main Camera must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.frontCamera == null || this.productDetail.frontCamera == "") {
                        swal("Sorry", "Product Front Camera must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else {
                        var storage = this.addStorageSmartphone[0] + "GB";
                        this.productDetailResult = {
                            brand: this.productDetail.brand,
                            model: (this.productDetail.model || "").replace(this.spaceRegex, ' ').trim(),
                            screen: this.productDetail.screen.toString(),
                            processor: (this.productDetail.processor || "").replace(this.spaceRegex, ' ').trim(),
                            ram: this.productDetail.ram.toString(),
                            storage: storage,
                            mainCamera: (this.productDetail.mainCamera || "").replace(this.spaceRegex, ' ').trim(),
                            frontCamera: (this.productDetail.frontCamera || "").replace(this.spaceRegex, ' ').trim(), 
                            battery: this.productDetail.battery,
                            feature: this.productDetail.feature,
                        };
                    }
                } else if (type == 3) {
                    if (this.productDetail.displaySize == null || this.productDetail.displaySize == "") {
                        swal("Sorry", "Display Size must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.displayType == null || this.productDetail.displayType == "") {
                        swal("Sorry", "Display Type must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.portVga == null || this.productDetail.portVga == "") {
                        swal("Sorry", "Port VGA must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.portDvid == null || this.productDetail.portDvid == "") {
                        swal("Sorry", "Port DVI-D must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.portHdmi == null || this.productDetail.portHdmi == "") {
                        swal("Sorry", "Port HDMI must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    }
                    this.productDetailResult = {
                        brand: this.productDetail.brand,
                        model: (this.productDetail.model || "").replace(this.spaceRegex, ' ').trim(),
                        displaySize: this.productDetail.displaySize.toString(),
                        displayType: this.productDetail.displayType,
                        portVga: this.productDetail.portVga,
                        portDvid: this.productDetail.portDvid,
                        portHdmi: this.productDetail.portHdmi,
                    };
                } else if (type == 4) {
                    if (this.productDetail.colorTech == null || this.productDetail.colorTech == "") {
                        swal("Sorry", "Color Technology must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    } else if (this.productDetail.feature == null || this.productDetail.feature == "") {
                        swal("Sorry", "Feature must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    }
                    this.productDetailResult = {
                        brand: this.productDetail.brand,
                        model: (this.productDetail.model || "").replace(this.spaceRegex, ' ').trim(),
                        colorTech: this.productDetail.colorTech,
                        feature: this.productDetail.feature,
                    };
                } else {       
                    if (this.productDetail.specifications == null || this.productDetail.specifications == "") {
                        swal("Sorry", "Product specifications must be fill", "error", {
                            button: "Ok",
                        });
                        return false;
                    }
                    this.productDetailResult = {
                        brand: this.productDetail.brand,
                        model: (this.productDetail.model || "").replace(this.spaceRegex, ' ').trim(),
                        specifications: this.productDetail.specifications,
                    };
                }
                return true;
            },
            openModal(x) {
                $("#modal" + x).modal("show");
            },
            toPage(e) {
                this.$router.push(e);
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem("jwt");
                localStorage.removeItem("admin_name");
                localStorage.removeItem("roles");
                localStorage.removeItem("user_email");
                localStorage.removeItem("admin_id");
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push("/");
            },
            cekLogin() {
                if (localStorage.getItem("jwt") == null) {
                    this.$router.push("/");
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem("roles").replace(/"/g, "").replace("[", "").replace("]", "").split(",");
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "1") {
                        this.viewDashboard = true;
                    }
                    if (this.permission[i] == "2.1") {
                        this.viewOrder = true;
                    }
                    if (this.permission[i] == "2.2") {
                        this.editOrder = true;
                    }
                    if (this.permission[i] == "3.1") {
                        this.viewReturn = true;
                    }
                    if (this.permission[i] == "3.2") {
                        this.editReturn = true;
                    }
                    if (this.permission[i] == "4.1") {
                        this.viewProduct = true;
                    }
                    if (this.permission[i] == "4.2") {
                        this.editProduct = true;
                    }
                    if (this.permission[i] == "5.1") {
                        this.viewPairing = true;
                    }
                    if (this.permission[i] == "5.2") {
                        this.editPairing = true;
                    }
                    if (this.permission[i] == "6") {
                        this.viewReconcile = true;
                    }
                    if (this.permission[i] == "7.1") {
                        this.viewResolution = true;
                    }
                    if (this.permission[i] == "7.2") {
                        this.editResolution = true;
                    }
                    if (this.permission[i] == "8.1") {
                        this.viewLessor = true;
                    }
                    if (this.permission[i] == "8.2") {
                        this.editLessor = true;
                    }
                    if (this.permission[i] == "9.1") {
                        this.viewLessee = true;
                    }
                    if (this.permission[i] == "9.2") {
                        this.editLessee = true;
                    }
                    if (this.permission[i] == "10") {
                        this.viewEmployee = true;
                    }
                }
                if (this.editProduct == false) {
                    this.$router.push("/");
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            removeImage(index) {
                                console.log('1 '+this.addPhoto[index]["photoId"])
                this.addPhoto[index] = this.initPhotoObject(this.addPhoto[index]["photoId"], "", "", "");
                console.log('2 '+this.addPhoto[index]["photoId"])
                document.getElementById("file_img_" + index).value = "";
                document.getElementById("show_img_" + index).src = "https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg";
            },
            onFilePicked(e, index) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    var imgFileName = files[0].name;
                    if (imgFileName.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener("load", () => {
                        var imgUrl = fr.result;
                        var imgFile = files[0]; // this is an image file that can be sent to server...
                        var imgBase64 = fr.result.split("base64,")[1];
                        if (imgFileName.toLowerCase().includes(".png")) {
                            if (imgFile.size >= 2000000) {
                                swal("Ukuran file tidak boleh lebih dari 2MB", "", "warning", {
                                    buttons: {
                                        agree: "OK",
                                    },
                                }).then((value) => {
                                    // this.pickFile()
                                });
                            } else {
                                var fuData = document.getElementById("file_img_" + index);
                                var FileUploadPath = fuData.value;
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    $("#show_img_" + index).attr("src", e.target.result);
                                };
                                reader.readAsDataURL(fuData.files[0]);
                                this.addPhoto[index] = this.initPhotoObject(this.addPhoto[index]["photoId"], imgFileName, imgBase64, imgUrl);
                            }
                        } else {
                            alert("Photo only allows file types of PNG. ");
                            this.addPhoto[index] = this.initPhotoObject(this.addPhoto[index]["photoId"], "", "", "");
                        }
                    });
                }
                console.log(this.addPhoto)
            },
            isNumber: function (evt) {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            getData() {
                this.pageAction = this.$route.query.f;
                this.isUnit = this.$route.query.unit == 1;
                this.loadingTable = true;
                this.isAddForm = this.$route.query.f == "Add";
                this.addRowProduct();
                this.getCategory();
                this.initPhoto();
                if(!this.isUnit){
                     this.$http
                    .get(process.env.GET_ALL_CATALOG, {
                        headers: {
                            "Asani-Token": localStorage.getItem("jwt"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                        } else if (response.data.status == 200) {
                            this.fProducts = response.data.content;
                            this.loadView()
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    });
                }else{
                    this.loadView()
                }

               
            },
            loadView(){
                if (this.isAddForm) {
                    this.addRowTenor();
                } else {
                    this.catalogId = this.$route.query.catalogId;
                    this.getCatalogEdit();
                }
            },
            getCategory() {
                this.$http
                    .get(process.env.GET_CATALOG_CREATE, {
                        headers: {
                            "Asani-Token": localStorage.getItem("jwt"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status !== 200) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                        } else {
                            this.catalogUnitType = response.data.content.catalogUnitType;
                            this.catalogCategory = response.data.content.catalogCategory;
                            this.loadingPage = false;
                            this.catalogBrand = Object.values(response.data.content.catalogBrand);
                            this.catalogBrand.push("Other");
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    });
            },
            getBom() {
                this.$http.get(process.env.GET_CATALOG_BOM + this.catalogId, {
                    headers: {
                            "Asani-Token": localStorage.getItem("jwt"),
                        },
                })
                .then(res => {
                    if(res.status == 200) {
                        this.totalBom = res.data.content.length
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            },
            getConditionList() {
                this.$http.get(process.env.GET_CONDITION_LIST, {
                    headers: {
                            "Asani-Token": localStorage.getItem("jwt"),
                        },
                })
                .then(res => {
                    if(res.status == 200) {
                        this.conditionList = res.data.content.map(item => {return {conditionName : item}})
                        // this.conditionList = res.data.content
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            },
        },
        created() {
            this.getData();
            this.admin = localStorage.getItem("admin_name");
            this.adminId = localStorage.getItem("admin_id");
            this.cekLogin();
            this.cekPermission();
            this.getConditionList()
            if(this.$route.query.f == 'Edit') {
                this.getBom()
            }
        },
    };
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .field-label{
        width: 188px;
    }
    .field-label.battery{
        width: 180px;
    }
    .field-label.screen{
        width: 186px;
    }
    .field-label.display-size{
        width: 180px;
    }
    .field-label.new-tenor{
        width: 194px;
    }
    .field-label.select{
        width: 188px;
    }
    .field-label.ram{
        width: 183px;
    }
    .field-label.select{
        width: 184px;
    }
    .field-label.storage{
        width: 418px;
    }
    .field-label.storage-ssd{
        width: 183px;
    }
    .field-label-one{
        width: 164px;
    }
    .field-label-one.screen{
        width: 180px;
    }
    .field-label-one.radio{
        width: 125px;
    }
    .field-label-one.rp{
        width: 158px;
    }
    .field-label-one.select{
        width: 158px;
    }
    .duration{
        width: 240px;
        margin-left: 5px;
    }
    .duration-new{
        width: 165px;
        margin-left: 5px;
    }

    .input-group-addon {
        padding: 7px 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        color: #555;
        text-align: center;
        background-color: #eee;
        border: 1px solid #ccc;
        border-radius: 4px 0px 0px 4px;
        border-right: none;
        margin: 0px 0px 0px 10px;
        height: fit-content;
    }

    .img-responsive{
        width: 257px;
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Catalog/CatalogAddPage.vue